import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import * as DateFns from 'date-fns';
import { colors, fonts } from '../../styles/theme';
import { Tooltip } from '../../ui_elements/tooltip/Tooltip';
import Avatar from '../../ui_elements/avatar/Avatar';
import Markdown from '../../base/Markdown';
import { Subtext } from '../../base/typography';
import { useRelativeTime } from '../../hooks';
import { FlexWrapper, FlexContent, AvatarPresenter } from './commentStyle';

const borderStyle = `1px solid ${colors.grey.secondaryDark}`;

const CommentReplyContainer = styled('div')`
  /* background-image: linear-gradient(to right, ${colors.grey
    .secondaryDark} 33%, transparent 0%); */
  background-size: 2px 1px;
  background-repeat: repeat-x;
  padding: 10px 20px;
  /* background: ${colors.grey.secondaryLight}; */
  border-top: ${borderStyle};
  border-style: dotted none none none;
  p {
    margin-block-start: 0;
    margin-block-end: 5px;
  };
  ${(props) => props.defaultView && `border-top: none`};
`;

const BodyContainer = styled('div')`
  font-family: ${fonts.sans.family};
  color: ${colors.black};
  padding-left: 28px;
  a {
    color: #2563eb;
    text-decoration: underline;
  }
`;

const ReplyName = styled(Subtext)`
  font-weight: 500;
  font-size: 13px;
  color: ${colors.black};
  margin-left: 28px;
`;

export function CommentReply(props) {
  const {
    avatar,
    fullName,
    body,
    authorTooltip,
    authorBadge,
    authorBadgeColor,
    formattedCreatedAt,
    defaultView
  } = props;

  const dateObject = (
    <span>{DateFns.format(new Date(formattedCreatedAt), 'MMM dd, yyyy h:mm a')}</span>
  );

  const [relativeDatetime] = useRelativeTime(formattedCreatedAt);

  return (
    <CommentReplyContainer defaultView={defaultView}>
      <AvatarPresenter>
        <FlexWrapper>
          <FlexContent>
            <Avatar
              src={avatar}
              alt={fullName}
              tooltip={{ text: authorTooltip }}
              badgeText={authorBadge}
              badgeColor={authorBadgeColor}
              size="xsmall"
            />
            <ReplyName>{fullName}</ReplyName>
          </FlexContent>
          <Subtext>
            <Tooltip content={dateObject}>
              <span>{relativeDatetime}</span>
            </Tooltip>
          </Subtext>
        </FlexWrapper>
      </AvatarPresenter>
      <div>
        <BodyContainer>
          <div>
            <Markdown>{body}</Markdown>
          </div>
        </BodyContainer>
      </div>
    </CommentReplyContainer>
  );
}

CommentReply.defaultProps = {
  body: '',
  authorTooltip: '',
  authorBadge: '',
  authorBadgeColor: '',
};

CommentReply.propTypes = {
  body: PropTypes.string,
  avatar: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  formattedCreatedAt: PropTypes.string.isRequired,
  authorTooltip: PropTypes.string,
  authorBadge: PropTypes.string,
  authorBadgeColor: PropTypes.string,
};

export default function ReplyChain(props) {
  const { replies } = props;

  const commentReplies = replies.map((reply) => {
    return <CommentReply {...reply} />;
  });

  return <div>{commentReplies}</div>;
}

ReplyChain.defaultProps = {
  replies: [],
};

const optionShape = {
  body: PropTypes.string,
  avatar: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  formattedCreatedAt: PropTypes.string.isRequired,
  authorIsEmployee: PropTypes.bool,
  authorIsManagingEditor: PropTypes.bool,
};

ReplyChain.propTypes = {
  replies: PropTypes.arrayOf(PropTypes.shape(optionShape)),
};
